import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateStandardStatements } from "../api/updateStandardStatements";

export const useUpdateStandardStatements = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => updateStandardStatements(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["standardStatements"] });
    },
  });
};

